export default {
  CLUB: 1,
  API: 2,
  MEMBER: 3,
  KIOSK: 4,
  IMPORT: 5,
};
